<template>
  <div class="box">
    <div class="row">
      <div class="col-lg-8 box-img-wrapper">
        <VideoWrapper v-if="isVideo" :videoLink="box.value2"></VideoWrapper>
        <ImageWrapper v-else :file="box.value2" :key="box.value2"></ImageWrapper>
      </div>
      <div class="col-lg-4 box-inner">
        <span class="box-tag">
          <span>{{box._embedded.Section.value}}</span>
        </span>
        <router-link :to="{name: 'CustomCompanyContent', params: {slug: slugify(box._embedded.Section.value)}}" class="box-title">
          <span v-html="box.valueDescription"></span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import ImageWrapper from "@/components/general/ImageWrapper";
import {slugify} from "@/helpers/slugify";
import VideoWrapper from "@/components/general/VideoWrapper";
export default {
  name: 'HomeCustomSectionBox',
  components: {VideoWrapper, ImageWrapper},
  props: ['box'],
  computed: {
    isVideo() {
      return this.box.value2 && (this.box.value2.includes('vimeo') || this.box.value2.includes('youtube'))
    }
  },
  methods: {
    slugify: slugify
  }
}
</script>
